import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { FootprintApiManager_DatasourceService } from './FootprintApiManager.datasource.index';
import { FootprintEdi_DatasourceService } from './FootprintEdi.datasource.index';

import { app_custom_ds_get_shipment_informationService } from './app.datasource.index';
import { app_ds_find_accountService } from './app.datasource.index';
import { app_ds_get_projects_by_project_and_ownerService } from './app.datasource.index';

@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_DatasourceService);
    this.FootprintEdi = this.injector.get(FootprintEdi_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public FootprintApiManager: FootprintApiManager_DatasourceService;
    public FootprintEdi: FootprintEdi_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_ds_get_shipment_information: app_custom_ds_get_shipment_informationService;
  public get custom_ds_get_shipment_information(): app_custom_ds_get_shipment_informationService {
    if(!this._custom_ds_get_shipment_information) {
      this._custom_ds_get_shipment_information = this.injector.get(app_custom_ds_get_shipment_informationService);
    }
    return this._custom_ds_get_shipment_information;
  }
  private _ds_find_account: app_ds_find_accountService;
  public get ds_find_account(): app_ds_find_accountService {
    if(!this._ds_find_account) {
      this._ds_find_account = this.injector.get(app_ds_find_accountService);
    }
    return this._ds_find_account;
  }
  private _ds_get_projects_by_project_and_owner: app_ds_get_projects_by_project_and_ownerService;
  public get ds_get_projects_by_project_and_owner(): app_ds_get_projects_by_project_and_ownerService {
    if(!this._ds_get_projects_by_project_and_owner) {
      this._ds_get_projects_by_project_and_owner = this.injector.get(app_ds_get_projects_by_project_and_ownerService);
    }
    return this._ds_get_projects_by_project_and_owner;
  }
}

